export default "__VITE_ASSET__CBVMeSN2__"